module.exports = __webpack_public_path__ + "img/49.f1143964.jpg";